import React, { useEffect } from 'react';

import { ReactComponent as TotalValue } from '../../../../assets/novosicones/Renegociacao/document_scanner_black_24dp.svg';

import { Item, ItemContent } from './styles.js';

const ValorTotal = ({
  regras,
  valorTotalAtualizado,
  setValorTotalAtualizado,
}) => {
  const format = (value) => {
    const options = {
      minimumFractionDigits: 2,
      style: 'currency',
      currency: 'BRL',
    };
    const result = new Intl.NumberFormat('pt-BR', options).format(
      value || valorTotalAtualizado
    );

    return result;
  };

  useEffect(() => {
    if (regras?.entrada) {
      let temp = regras?.valorTotal - regras?.entrada;

      setValorTotalAtualizado(temp);
    } else {
      setValorTotalAtualizado(regras?.valorTotal);
    }
  }, [regras?.entrada]);

  return (
    <Item>
      <span>
        <b>Valor total atualizado:</b>
      </span>
      <ItemContent style={{ border: '2px solid #d1d1d1' }}>
        <div>
          <TotalValue
            className='iconeRenegociacao'
            style={{ fill: '#4d4d4d' }}
          />
        </div>
        <span id={'txtValorTotalAtualizado'}>
          <b>{format(valorTotalAtualizado)}</b>
        </span>
      </ItemContent>
      <span>
        *Valor referente às <b>parcelas em renegociação.</b>:
      </span>
    </Item>
  );
};

export default ValorTotal;
